module.exports = __webpack_public_path__ + "img/TerminalStamp-Customhouse.07ad7347.webp";